import parse from 'html-react-parser';
import React, { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  isHiddenInPrint,
  itemBottomGapStyle,
  itemTitleStyle,
  lineHeightStyle,
  styledComponent,
} from '../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../chiefComplainDeleteBtn';

const SpecialNoteView = ({
  selectedSpecialNotes,
  setSelectedSpecialNotes,
  setShowSpecialNote,
  prescriptionItems,
  element,
  isHistoryPage = false,
}) => {
  const Title = styledComponent(
    prescriptionItems?.items?.['special-note']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['special-note']?.subItemStyle || {},
  );
  const deleteSpecialNote = (specialNoteId) => {
    selectedSpecialNotes = selectedSpecialNotes.filter(
      (specialNote) => specialNote?.note !== specialNoteId,
    );
    setSelectedSpecialNotes([...selectedSpecialNotes]);
  };

  const prescriptionItemCSSObject = () => itemBottomGapStyle(element, !selectedSpecialNotes?.length);

  return (
    <div
      className={`row item-row special-note-view ${
        selectedSpecialNotes?.length ? 'data-item' : ''
      }`}
      style={prescriptionItemCSSObject()}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'special-note')
            ? 'item-title-hide'
            : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['special-note']?.itemStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowSpecialNote(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>Special Note</span>
        )}
      </span>
      <ul
        className="sub-child-list special-note-view"
        style={{
          ...lineHeightStyle('special-note', prescriptionItems),
          paddingRight: '7px',
        }}
      >
        {selectedSpecialNotes?.map((item, index) => {
          if (item.groupName || item.note) {
            return (
              <li key={index}>
                {item?.groupName && (
                  <>
                    <Row className="">
                      <Col className="groupName">
                        <Title>{item.groupName}</Title>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="special-note">
                        <Value>{parse(item.note)}</Value>
                      </Col>
                      <Col sm={1}>
                        <ChiefComplainDeleteBtn
                          action={deleteSpecialNote}
                          itemName={item?.note}
                          delId={''}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {!item?.groupName && item.note && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span className="special-note">{parse(item.note)}</span>
                    <ChiefComplainDeleteBtn
                      action={deleteSpecialNote}
                      itemName={item?.note}
                      delId={''}
                    />
                  </div>
                )}
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );
};

export default memo(SpecialNoteView);
